export const journey2 = {
    id: 'journey-2',
    schemaVersion: 2,
    covers: 'Atmosphere only: a long, wordless run of treatment footage. It cannot carry a stated idea and should be planned as mood, not as a message.',
    aspectRatios: ['portrait'],
    duration: {
        kind: 'fixed',
        frames: 1048,
    },
    root: {
        kind: 'leaf',
        id: 'main',
        spine: [
            {
                kind: 'media-track',
                id: 'broll',
                duration: {
                    kind: 'fill',
                },
                clips: {
                    source: 'query',
                    query: {
                        kind: 'asset-clips',
                        tag: 'procedure',
                        count: [1, 14],
                    },
                    required: true,
                },
                fit: 'contain-blur',
                kenBurnsOnImages: true,
                cuts: {
                    mode: 'at',
                    at: [
                        {
                            atSec: 2.1,
                            transition: 'fade',
                        },
                        {
                            atSec: 3.5,
                            transition: 'fade',
                        },
                        {
                            atSec: 5.1,
                            transition: {
                                mask: 'wedge-cross',
                            },
                        },
                        {
                            atSec: 8.933,
                            transition: 'fade',
                        },
                        {
                            atSec: 9.267,
                            transition: {
                                mask: 'bar-wipe-right',
                            },
                        },
                        {
                            atSec: 10.333,
                            transition: 'fade',
                        },
                        {
                            atSec: 12.533,
                            transition: 'fade',
                        },
                        {
                            atSec: 14.733,
                            transition: 'fade',
                        },
                        {
                            atSec: 17.3,
                            transition: 'fade',
                        },
                        {
                            atSec: 19.267,
                            transition: 'fade',
                        },
                        {
                            atSec: 22.067,
                            transition: 'whip-up',
                        },
                        {
                            atSec: 24.333,
                            transition: 'fade',
                        },
                        {
                            atSec: 27.267,
                            transition: 'cut',
                        },
                        {
                            atSec: 32.833,
                            transition: 'fade',
                        },
                        {
                            atSec: 33.267,
                            transition: 'fade',
                        },
                    ],
                },
            },
            {
                kind: 'panel-stack',
                id: 'opening-stack',
                duration: {
                    kind: 'fixed',
                    frames: 63,
                },
                clip: {
                    source: 'query',
                    query: {
                        kind: 'asset-media',
                        tag: 'procedure',
                        mediaType: 'video',
                    },
                    required: false,
                },
                fit: 'cover',
                panels: [256, 519, 505],
                axis: 'h',
                stacked: {
                    sizes: [254, 465, 403],
                    inset: {
                        top: 0,
                        right: 0,
                        bottom: 0.082,
                        left: 0.1111,
                    },
                    gutter: 0.0207,
                    show: {
                        x: 0.5,
                        y: 0.5,
                    },
                    zoom: 2,
                },
                holdSec: 0.767,
                resolveSec: 0.433,
                easing: 'ease-in',
            },
        ],
        overlays: [
            {
                kind: 'group',
                id: 'flash-warm',
                start: {
                    at: 'frame',
                    value: 304,
                },
                duration: {
                    kind: 'fixed',
                    frames: 15,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'light',
                    color: '#FF7A14',
                    size: 4,
                    falloff: 1,
                    intensity: 0.95,
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 0.75,
                                duration: 4,
                                easing: 'ease-out',
                            },
                            {
                                channel: 'opacity',
                                from: 0.75,
                                to: 0.45,
                                duration: 2,
                                easing: 'ease-in-out',
                                anchor: {
                                    at: 'start',
                                    frame: 4,
                                },
                            },
                            {
                                channel: 'opacity',
                                from: 0.45,
                                to: 0.68,
                                duration: 3,
                                easing: 'ease-out',
                                anchor: {
                                    at: 'start',
                                    frame: 6,
                                },
                            },
                            {
                                channel: 'opacity',
                                from: 0.68,
                                to: 0,
                                duration: 5,
                                easing: 'ease-in',
                                anchor: {
                                    at: 'start',
                                    frame: 9,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'flash-core',
                start: {
                    at: 'frame',
                    value: 307,
                },
                duration: {
                    kind: 'fixed',
                    frames: 9,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'light',
                    color: '#E4EEFF',
                    size: 4,
                    falloff: 1,
                    intensity: 0.95,
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 0.78,
                                duration: 3,
                                easing: 'ease-out',
                            },
                            {
                                channel: 'opacity',
                                from: 0.78,
                                to: 0,
                                duration: 6,
                                easing: 'ease-in',
                                anchor: {
                                    at: 'start',
                                    frame: 3,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'right-light-sweep',
                start: {
                    at: 'frame',
                    value: 585,
                },
                duration: {
                    kind: 'fixed',
                    frames: 77,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'light',
                    color: '#FF8A2B',
                    size: 2.2,
                    falloff: 1,
                    intensity: 0,
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 0.502,
                                duration: 16,
                                easing: 'ease-out',
                            },
                            {
                                channel: 'opacity',
                                from: 0.502,
                                to: 0.21,
                                duration: 16,
                                easing: 'ease-in-out',
                                anchor: {
                                    at: 'start',
                                    frame: 16,
                                },
                            },
                            {
                                channel: 'opacity',
                                from: 0.21,
                                to: 0.461,
                                duration: 32,
                                easing: 'ease-in-out',
                                anchor: {
                                    at: 'start',
                                    frame: 32,
                                },
                            },
                            {
                                channel: 'opacity',
                                from: 0.461,
                                to: 0,
                                duration: 13,
                                easing: 'ease-in',
                                anchor: {
                                    at: 'start',
                                    frame: 64,
                                },
                            },
                            {
                                channel: 'x',
                                from: -194,
                                to: 238,
                                duration: 77,
                                easing: 'linear',
                            },
                            {
                                channel: 'y',
                                from: -58,
                                to: 403,
                                duration: 32,
                                easing: 'ease-in-out',
                            },
                            {
                                channel: 'y',
                                from: 403,
                                to: -19,
                                duration: 45,
                                easing: 'ease-in-out',
                                anchor: {
                                    at: 'start',
                                    frame: 32,
                                },
                            },
                            {
                                channel: 'scale',
                                from: 0.8,
                                to: 1.5,
                                duration: 77,
                                easing: 'linear',
                            },
                        ],
                    },
                },
            },
        ],
    },
    globals: {
        audio: {
            music: {
                source: 'query',
                query: {
                    kind: 'music',
                },
                required: false,
            },
        },
    },
};
//# sourceMappingURL=journey-2.js.map